import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { ExtraProduct } from './extraproduct';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ExtraProductType } from '../types';
import { ProductOptType } from '../types';

const _schema = {
    "name": "EXTRAPRODUCTOPT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "product", type: "objid" },
        { name: "prodopt", type: "objid", alias: "option" },
    ],
    relate: [
        { direction: ">", target: "EXTRAPRODUCT", by: "product", name: "product", reason: "product", child: false, class: ExtraProductType },
        { direction: ">", target: "PRODUCTOPT", by: "option", name: "option", reason: "option", child: false, class: ProductOptType }
    ]
} as const;

const _ExtraOptionClass = CreateObject(_schema);
if (!_ExtraOptionClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class ExtraOption extends _ExtraOptionClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): ExtraOption {
        return this._Copy(store) as ExtraOption;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'product' && related instanceof ExtraProduct){
            if (related === this.product){
                related.AddOption(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.product){
            if ((this.status == 'DE') && !this.Commited){
                this.product.DelOption(this);
            }
            else {
                this.product.DoRefresh(this.table);
            }    
        }
    }    

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }    
}
